import { render, staticRenderFns } from "./DocumentPublishModal.vue?vue&type=template&id=d555fd00"
import script from "./DocumentPublishModal.vue?vue&type=script&lang=ts"
export * from "./DocumentPublishModal.vue?vue&type=script&lang=ts"
import style0 from "./DocumentPublishModal.vue?vue&type=style&index=0&id=d555fd00&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports